import voucherBulkMessageModalCreator from "../../../../modules/messages/helpers/voucher-bulk-message-modal-creator";

class SendVouchersWorkflow {
    constructor(Alert, $http, locale, ResourceCommon, $injector) {
        this.key = 'send-vouchers';
        this.title = 'Send Vouchers';
        this.level = 'selected';
        this.alert = Alert;
        this.locale = locale;
        this.api = $http;
        this.injector = $injector;
        this.resourceCommon = ResourceCommon;
    }

    action({}, store) {
        voucherBulkMessageModalCreator(this.injector, store);
    }
}


angular
    .module('festzelt-os.vouchers.main')
    .factory('sendVouchers', [
        'Alert',
        '$http',
        'locale',
        'ResourceCommon',
        '$injector',
        (Alert, $http, locale, ResourceCommon, $injector) => new SendVouchersWorkflow(Alert, $http, locale, ResourceCommon, $injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/workflows/send-vouchers.js